import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaService } from '@core/services/pwa/pwa.service';
import { ToastService } from '@core/services/toast/toast.service';

@Component({
  selector: 'app-pwa-install-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pwa-install-toast.html',
  styleUrls: ['./pwa-install-toast.css'],
})
export class PwaInstallToastComponent {
  readonly pwaService = inject(PwaService);
  private readonly toastService = inject(ToastService);

  isInstalling = false;

  async onInstall(): Promise<void> {
    if (this.pwaService.isIOS()) {
      this.pwaService.toggleIOSInstructions();
      return;
    }

    this.isInstalling = true;
    try {
      const accepted = await this.pwaService.installPwa();
      if (accepted) {
        this.toastService.showToast('Installation de Gymo lancée !', false);
      }
    } finally {
      this.isInstalling = false;
    }
  }

  onDismiss(): void {
    this.pwaService.dismissPrompt(1);
  }

  onReloadUpdate(): void {
    this.pwaService.reloadForUpdate();
  }
}
